import { CommonTabbarContext } from "@/App";
import { getServerDetail } from "@/api/device/server";
import { DEVICE_TYPE } from "@/enums/device-type";
import { TAB_TYPE } from "@/enums/tab-type";
import { CommonTabbarState, TabRoute } from "@/global/components/common-tabbar";
import { getShortDateName } from "@/global/utils/date-utils";
import { Server } from "http";
import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router";
import "./index.less"
import { findTotalTestListByTimeAndProjectId } from "@/api/device/device";
import { DeviceTotalTestConnectHistory } from "@/global/interface/device/device";
import { TEST_RETURN_STATUS } from "@/enums/test-return-status";
import classNames from "classnames";
import { Sensor, SensorParameter } from "@/global/interface/device/sensor";
import SensorCollectionDataPanel from "@/global/components/sensor-collection-data-panel";
import { getSensorDetail } from "@/api/device/sensor";

export default function TestRecordPanel(second) {

    const { testDate, projectId } = useParams()
    const commonTabbarContext = useContext<CommonTabbarState>(CommonTabbarContext);
    const [testDataList, setTestDataList] = useState<DeviceTotalTestConnectHistory[]>([])
    const [activeDataId, setActiveDataId] = useState<number>()
    const [hoverDataId, setHoverDataId] = useState<number>(0)
    const [sensor, setSensor] = useState<Sensor>(null)
    const [dataPanelVisible, setDataPanelVisible] = useState<boolean>(false)

    // 初始化
    useEffect(() => {
        if (!testDate) return;
        let addTab: TabRoute = {
            title: getShortDateName(Number(testDate)) + " 测试记录",
            url: `${TAB_TYPE.TEST_RECORD}/${testDate}`,
            closable: true
        }
        commonTabbarContext.pushRoute(addTab)
        generateDate()
    }, [testDate])

    const generateDate = () => {
        if (!testDate) return;
        findTotalTestListByTimeAndProjectId(Number(projectId), Number(testDate)).then(res => {
            setTestDataList(res?.data || [])
        })
    }

    const onClickShowData = (item: DeviceTotalTestConnectHistory) => {
        getSensorDetail(item.sensorId).then(res => {
            setSensor(res.data)
            setDataPanelVisible(true)
            setActiveDataId(item.id)
        })
    }

    return (
        <div className="record-panel-main">
            <div className="record-title">
                <div className="total-num">
                    测试设备数量
                    <div className="num">
                        {testDataList?.length || 0}
                    </div>
                </div>
                <div className="error">
                    <div className="name">
                        异常设备数量
                    </div>
                    <div className="num">
                        {testDataList?.filter(item =>
                            item.testStatus != TEST_RETURN_STATUS.ERROR_EMPTY_OBJECT &&
                            item.testStatus != TEST_RETURN_STATUS.SUCESS).length || 0}
                    </div>
                </div>
                <div className="un-install">
                    未安装设备数量
                    <div className="num">
                        {testDataList?.filter(item => item.testStatus == TEST_RETURN_STATUS.ERROR_EMPTY_OBJECT).length || 0}
                    </div>
                </div>
                <div className="success">
                    已通过设备数量
                    <div className="num">
                        {testDataList?.filter(item => item.testStatus == TEST_RETURN_STATUS.SUCESS).length || 0}
                    </div>
                </div>
            </div>
            <div className="list">
                {testDataList?.map((item, index) => (
                    <div className={classNames({
                        "item": true,
                        "item-active": activeDataId == item.id
                    })} key={index}
                        onMouseEnter={() => { setHoverDataId(item.id) }}
                        onMouseLeave={() => { setHoverDataId(null) }}>
                        <div className={classNames({
                            "icon": true,
                            "icon-success": item.testStatus == TEST_RETURN_STATUS.SUCESS,
                            "icon-error": item.testStatus != TEST_RETURN_STATUS.SUCESS && item.testStatus != TEST_RETURN_STATUS.ERROR_EMPTY_OBJECT,
                            "icon-un-install": item.testStatus == TEST_RETURN_STATUS.ERROR_EMPTY_OBJECT,
                        })} />
                        <div className="name">
                            {item.name}
                        </div><div className="btn-area">
                            {(activeDataId == item.id || hoverDataId == item.id) && (item.sensorId) && (
                                <div className="show-btn" onClick={() => { onClickShowData(item) }}>
                                    数据显示
                                </div>
                            )}
                        </div>
                        <div className="detail">
                            {item.testStatus == TEST_RETURN_STATUS.SUCESS ? ("数据正常，测试通过") : ("数据异常，测试不通过")}
                        </div>
                    </div>
                ))}

            </div>

            {dataPanelVisible &&
                <SensorCollectionDataPanel
                    setShow={setDataPanelVisible}
                    params={sensor?.sensorParameters}
                    sensorId={sensor?.id}
                />}

        </div>
    )
}